<template>
  <!--언어 선택-->
  <div class="container-contents">
    <button
      class="button-dim button-full-width button-small"
      ref="triggerLanRef"
      @click="toggleDropdown"
      :class="{
        active: showDropdown,
      }"
    >
      <p>
        {{ languageSelected.name ? languageSelected.name : '언어 선택' }}
      </p>
      <component
        class="icon-medium"
        :is="showDropdown ? ChevronUpIcon : ChevronDownIcon"
      />
    </button>

    <Dropdown
      v-if="showDropdown"
      position="below"
      :trigger-ref="triggerLanRef"
      :class="{ active: showDropdown }"
      @close="toggleDropdown"
    >
      <LanguageList
        :checked-languages="languagePresets"
        show-all-in-list
        selected-at-top
        :show-checkbox="props.showCheckbox"
        align-left
        @select="selectLanguage"
        @update:checked-languages="checkLanguage"
      />
    </Dropdown>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref } from 'vue';

import ChevronDownIcon from '@/components/icons/IconChevronDown.vue';
import ChevronUpIcon from '@/components/icons/IconChevronUp.vue';
import Dropdown from '@/components/shared/base/Dropdown.vue';
import LanguageList from '@/components/shared/base/LanguageList.vue';
import { useSocketsStore } from '@/stores/sockets';
import { useToastStore } from '@/stores/toast';
import { Language } from '@/types/common';

const socketsStore = useSocketsStore();

const languageSelected = defineModel<Language>('languageSelected', {
  required: true,
  default: () => ({
    code: '',
    name: '',
    nameInKorean: '',
    smallName: '',
  }),
});
const languagePresets = defineModel<Language[]>('languagePresets', {
  required: true,
  default: () => [],
});

const props = withDefaults(
  defineProps<{
    id: string;
    showCheckbox?: boolean;
  }>(),
  {
    id: '',
    showCheckbox: true,
  }
);
const toastStore = useToastStore();

const triggerLanRef = ref();
const showDropdown = ref<boolean>(false);

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
};

const checkLanguage = (language) => {
  const inx = languagePresets.value.findIndex(
    (preset) => preset.code === language.code
  );

  if (inx === -1) {
    languagePresets.value.push(language);
    if (languagePresets.value.length > 3) {
      languagePresets.value.splice(0, 1);
    }
  } else {
    languagePresets.value.splice(inx, 1);
  }
};

const selectLanguage = (language) => {
  languageSelected.value = language;
  if (socketsStore.connections.has(props.id)) {
    socketsStore.sendMessageChangeLanguage(props.id, language.code);
    toastStore.info(`${language.name}로 통역합니다.`);
  }
  toggleDropdown();
};
</script>

<style scoped lang="scss">
.container-contents {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 3rem;
  gap: 0.25rem;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
}

p {
  line-height: 120%;
  width: 100%;
  text-align: left;
}

::v-deep(.dropdown-content) {
  width: 12rem;
}

</style>
